import { NSDialogInfo, NSDialogInfoProps } from './NSDialogInfo';
import { NSButtonGreen } from "./NSButtonGreen";
import { NSButtonRed } from "./NSButtonRed";
import { NSSpace, NSSpaceSizeType } from "./NSSpace";
import { NSRow } from './NSRow';
import { NSButtonOnClickProps } from './NSButton';

export interface NSDialogDeleteProps extends NSDialogInfoProps
{
    onYes: NSButtonOnClickProps;
    onNo: NSButtonOnClickProps;
}

export function NSDialogDelete(props: NSDialogDeleteProps) 
{
    return (
        <NSDialogInfo {...props}
            onClose={props.onClose}
        >
            {props.children}
            <NSSpace size={NSSpaceSizeType.MINI}></NSSpace>
            <NSRow>
                <NSButtonGreen title="Yes" onClick={props.onYes} />
                <NSButtonRed title="No" onClick={props.onNo} />
            </NSRow>
        </NSDialogInfo>
    );
}